import React, {useEffect} from 'react';
import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import {connect} from "react-redux";
import {container} from "@Container";
import {TYPES} from "@Types";
import Scroll from "react-scroll";
import FormatArmyListForm from "./FormatArmyListForm";
import {ArmyListFormatPresenter} from "@Selectors/builder/myBuilder/builder/format/ArmyListFormatPresenter";
import {FormatParams} from "./validate";
import { ArmyListAction } from '@Redux/actions';
import myBuilderSlice from '@Redux/reducers/builder/myBuilder.slice';

const ArmyListFormat: React.FC<FormatArmyListProps> = ({
                                                         cancel,
                                                         datas,
                                                         handleSubmit,
                                                         handleImport,
                                                       }) => {
  useEffect(() => {
    Scroll.scroller.scrollTo('FormatArmyListElement', {
      duration: 1000,
      delay: 100,
      smooth: true,
      offset: -50, // Scrolls to element + 50 pixels down the page
    });
  }, []);
  const Element = Scroll.Element;

  return (
    <div className="mt-2">
      <Element name="FormatArmyListElement"/>
      <FormatArmyListForm cancel={cancel} onSubmit={handleSubmit} onImport={handleImport}
                          canSubmit={datas.canSubmit} canImport={datas.canImport}/>
    </div>
  );
}

const mapStateToProps = (state: AppState) => ({
  datas: ArmyListFormatPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListAction = container.get<ArmyListAction>(TYPES.Actions.ArmyListAction);
  return {
    cancel: () => dispatch(myBuilderSlice.actions.cancel()),
    handleSubmit: (values: FormatParams) => {
      dispatch(armyListAction.formatArmyList(Math.round(new Date(values.date).getTime() / 1000), values.game, values.source));
    },
    handleImport: (values: FormatParams) => {
      dispatch(armyListAction.importArmyList(values.formatedArmyList));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListFormat);

type FormatArmyListProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
